import {useEffect} from 'react'
import {useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const usePutFranchiseManagerPassword = (onSuccess) => {
	const {idx} = useParams()

	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const request = (newPassword) => {
		fetchRequest('PUT', `/admin/franchise/manager/${idx}`, {
			new_password: newPassword,
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				setAlert('비밀번호가 성공적으로 변경되었습니다.')
				if (onSuccess) {
					onSuccess()
				}
				break
			case 400:
				if (fetchResult?.data?.error_code === 'new_password')
					setAlert('새 비밀번호 형식을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				setAlert('매니저 데이터가 존재하지 않습니다.')
				break
			default:
				break
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fetchResult])

	return [request, isLoading, fetchResult]
}

export default usePutFranchiseManagerPassword
